import React, { useEffect, useState } from "react";

const DashboardTableHeaderStyles = ({ children, saleCode, value }) => {
  const [headerClass, setHeaderClass] = useState("");

  useEffect(() => {
    const days = [
      "header-sunday",
      "header-monday",
      "header-tuesday",
      "header-wednesday",
      "header-thursday",
      "header-friday",
      "header-saturday",
    ];
    setHeaderClass(days[new Date().getDay()]);
  }, []);

  const bgColor =
    Number(saleCode) === 2
      ? "#52bd91"
      : Number(saleCode) === 1
        ? "#52bd91"
        : value === true
          ? "#FF9902"
          : "#52bd91";

  return (
    <div className={`dashboard-table-wrap ${headerClass}`}>
      {children}
      <style jsx>{`
        /* Target ALL th — high specificity */
        .dashboard-table-wrap .ant-table-thead > tr > th,
        .dashboard-table-wrap .ant-table-thead > tr > td {
          background-color: ${bgColor} !important;
          color: #fff !important;
        }

        /* Override the first-child rule from styles.css */
        .dashboard-table-wrap
          .ant-table-wrapper
          .ant-table-container
          table
          > thead
          > tr:first-child
          > *:first-child,
        .dashboard-table-wrap
          .ant-table-wrapper
          .ant-table-container
          table
          > thead
          > tr:first-child
          > *:last-child {
          background-color: ${bgColor} !important;
          color: #fff !important;
        }

        /* Cover every th via nth-child just to be safe */
        .dashboard-table-wrap
          .ant-table-container
          table
          > thead
          > tr
          > th:nth-child(n) {
          background-color: ${bgColor} !important;
          color: #fff !important;
        }
      `}</style>
    </div>
  );
};

export default DashboardTableHeaderStyles;